import { useCallback, useEffect, useRef } from "react";

/**
 * ビューポートに固定したレイヤーを「ページと一緒にスクロールし、背景の下端まで来たらそこで止まる」
 * 挙動にする。止まったあとは、その上をコンテンツ(本文やフッター)だけが流れていく。
 *
 * @param {number} backgroundBottom
 *   背景の下端のドキュメント座標(px)。画像の読み込み待ちなどで 0 以下の間は何もしない。
 * @returns {{ ref: React.MutableRefObject<HTMLElement|null> }} transform を適用する要素の ref
 */
export default function useClampedScroll(backgroundBottom) {
  const ref = useRef(null);

  const handleScroll = useCallback(() => {
    if (!ref.current || !(backgroundBottom > 0)) return;
    const maxScroll = Math.max(backgroundBottom - window.innerHeight, 0);
    const clamped = Math.min(window.scrollY, maxScroll);
    ref.current.style.transform = `translateY(${-clamped}px)`;
  }, [backgroundBottom]);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [handleScroll]);

  return { ref };
}
